export default __webpack_public_path__ + "static/media/fullscreen.feffbe15.svg";